<template>
  <svg viewBox="0 0 90 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M69.75 50H79.75L44.75 0L10 50H19.75L0.25 80H34.85V100H54.6V80H89.75L69.75 50ZM18.7 70L38.2 40H29.15L44.8 17.5L60.55 40H51.05L71.05 70H18.7Z"
      fill="currentColor"
    />
  </svg>
</template>
